import ConfirmationWithBackButton from 'src/components/Compliance/ConfirmationWithBackButton';
import MessageBox from 'src/components/Compliance/MessageBox';
import BadgeImg from '../../assets/images/FramedImage.png';
import Logomark from '../../assets/images/Logomark.png';

const AlreadyCoverageVerified = () => {
  return (
    <ConfirmationWithBackButton
      title="You have already verified your policy"
      subtitle="Check your inbox for a confirmation email."
      image={BadgeImg}
      goBackLink="/compliance/welcome"
      message=
        <MessageBox
          image={Logomark}
          title="Still have question?"
        />
    />
  );
};

export default AlreadyCoverageVerified;
